import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/web.dom-collections.for-each.js";
import Gikam from '../../../core/gikam-core';
export var ModalUtils = /*#__PURE__*/function () {
  function ModalUtils() {
    _classCallCheck(this, ModalUtils);
  }

  _createClass(ModalUtils, null, [{
    key: "initItems",
    value: function initItems(modal) {
      if (Gikam.isEmpty(modal.options.items)) {
        return;
      }

      modal.options.items.forEach(function (item) {
        item.renderTo = modal.window.$dom;
        Gikam.create(item.type, item);
      });
    }
  }]);

  return ModalUtils;
}();